'use client';

import { CatwalkProvider } from '@frontastic/catwalk/js/CatwalkProvider';
import LegacyFrontasticRenderer from '@frontastic/bridge/js/legacyRenderer';
import { tastics } from '@apgnext/frontend/frontastic/tastics';
import { Providers, ProvidersProps } from '../../../providers';

export const LegacyRendererWithCatwalkProvider: React.FunctionComponent<ProvidersProps> = ({
  page,
  translations,
  accountResult,
  hostname,
  locale,
}) => {
  if (page.isError === true) {
    // This can never happen, just for TypeScript
    throw new Error(page.error.message);
  }

  return (
    <Providers
      translations={translations}
      page={page}
      locale={locale}
      hostname={hostname}
      accountResult={accountResult}
    >
      <CatwalkProvider messages={{}} pageData={page.data}>
        <LegacyFrontasticRenderer data={page.data} tastics={tastics} />
      </CatwalkProvider>
    </Providers>
  );
};
